/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import FormCreator from "../../../../../components/FinalForms/FormCreator";
import Buttons from "../../../../../components/ui/button/Buttons";
import { AppIcons } from "../../../../../data/appIcons";
import addCandidateFields from "../AddCandidate.Data";
import { useAddCandidateMutation } from "../../../../../app/services/candidateAPI";
import {
  useLazyGetPositionQuery,
  useLazyGetHRListQuery,
} from "../../../../../app/services/positionAPI";
import { useLazyGetAllSkillQuery } from "../../../../../app/services/skillAPI";
import ToastService from "../../../../../services/toastService/ToastService";
import { getAuthProps } from "../../../../../lib/authenticationLibrary";
import { formatDateToISO } from "../../../../../lib/formatDate";
import CenterModel from "../../../../../components/ui/centerModel/CenterModel";
import UploadResumeCandidate from "./UploadResumeCandidate";
import { setDropDownOptionField } from "../../../../../utils/FormFields/FieldsSetting/SetFieldSetting";

const initState = {
  firstName: "",
  lastName: "",
  contactEmail: "",
  contactPhone: "",
  positionApplied: null,
  responsibleUser: null,
  candidateResume: "",
};

const AddUserForm = (props) => {
  const candidateRef = useRef();
  const cookie = getAuthProps();
  const [showModal, setShowModal] = useState(false);
  const [candidateForm, setCandidateForm] = useState(addCandidateFields);
  const [shouldRerenderFormCreator, setShouldRerenderFormCreator] =
    useState(false);

  const [
    addCandidate,
    {
      isSuccess: isCandidateAdded,
      isLoading: isCandidateAdding,
      data: addCandidateData,
    },
  ] = useAddCandidateMutation();

  const [
    getPosition,
    {
      isFetching: isPositionFetching,
      isSuccess: isPosition,
      data: positionData,
    },
  ] = useLazyGetPositionQuery();

  const [
    getHRList,
    { isFetching: isHRListFetching, isSuccess: isHRList, data: HRData },
  ] = useLazyGetHRListQuery();

  const [
    getAllSkill,
    {
      isFetching: isSkillFetching,
      isSuccess: isAllSkillFetched,
      data: skillsData,
    },
  ] = useLazyGetAllSkillQuery();

  useEffect(() => {
    if (props.isOpen) {
      getPosition();
      getAllSkill();
      getHRList();
    }
  }, [props.isOpen]);

  const handleAddClick = () => {
    const candidateFormData = candidateRef.current.getFormData();
    if (candidateFormData) {
      const techId = candidateFormData?.skillId?.map((item) => ({
        skillId: item,
      }));
      let skillId = techId?.map((item) => item.skillId).join(",");

      const requestData = {
        ...candidateFormData,
        contactPhone: candidateFormData.contactPhone
          .replace(/\D/g, "")
          .slice(-10),
        candidateResume: candidateFormData.candidateResume
          ? typeof candidateFormData.candidateResume === "object"
            ? candidateFormData.candidateResume.fileName
            : candidateFormData.candidateResume
          : null,
        base64File: candidateFormData.candidateResume?.base64Data
          ? candidateFormData.candidateResume.base64Data
          : null,
        positionApplied: candidateFormData.positionApplied?.value,
        responsibleUser: candidateFormData.responsibleUser?.value,
        storagePath: "Resume",
        skillId: skillId ,
        applyDate: candidateFormData.applyDate
          ? formatDateToISO(candidateFormData.applyDate)
          : null,
        createdBy: cookie && cookie.user && cookie.user.userID,
      };

      addCandidate(requestData);
    }
  };

  useEffect(() => {
    resetForm();
  }, [props.onClose]);

  const handleClear = () => {};

  const resetForm = () => {
    const formData = { ...candidateForm };
    formData.initialState = { ...initState };
    setCandidateForm(formData);
  };

  useEffect(() => {
    if (isCandidateAdded && addCandidateData) {
      if (addCandidateData.errorMessage.includes("exists")) {
        ToastService.warning(addCandidateData.errorMessage);
        return;
      } else {
        props.onClose();
        ToastService.success(addCandidateData.errorMessage);
        resetForm();
      }
    }
  }, [isCandidateAdded, addCandidateData]);

  useEffect(() => {
    if (!isPositionFetching && isPosition && positionData) {
      // const positionListData = positionData.map((item) => ({
      //   value: item.positionAppliedId,
      //   label: item.positionName,
      // }));
      // const dropdownField = addCandidateFields.formFields.find(
      //   (item) => item.dataField === "positionApplied"
      // );
      // dropdownField.fieldSetting.options = positionListData;
      setDropDownOptionField(
        positionData,
        "positionAppliedId",
        "positionName",
        addCandidateFields,
        "positionApplied"
      );
      //  setShouldRerenderFormCreator((prevState) => !prevState);
    }
  }, [isPositionFetching, isPosition, positionData]);

  useEffect(() => {
    if (!isHRListFetching && isHRList && HRData) {
      // const hrListData = HRData.map((item) => ({
      //   value: item.userId,
      //   label: item.fullName,
      // }));
      // const dropdownField = addCandidateFields.formFields.find(
      //   (item) => item.dataField === "responsibleUser"
      // );
      // dropdownField.fieldSetting.options = hrListData;
      // setShouldRerenderFormCreator((prevState) => !prevState);
      setDropDownOptionField(
        HRData,
        "userId",
        "fullName",
        addCandidateFields,
        "responsibleUser"
      );
    }
  }, [isHRListFetching, isHRList, HRData]);

  useEffect(() => {
    if (!isSkillFetching && isAllSkillFetched && skillsData) {
      // const allSkillData = skillsData.map((item) => ({
      //   value: item.skillId,
      //   label: item.skillName,
      // }));
      // const dropdownField = addCandidateFields.formFields.find(
      //   (item) => item.dataField === "skillId"
      // );
      // dropdownField.fieldSetting.options = allSkillData;
      // setShouldRerenderFormCreator((prevState) => !prevState);
      setDropDownOptionField(
        skillsData,
        "skillId",
        "skillName",
        addCandidateFields,
        "skillId"
      );
    }
  }, [isSkillFetching, isAllSkillFetched, skillsData]);

  const handleActionChange = (actionName, formData, actionData, dataField) => {
    if (actionName === "CLEAR") {
      const updatedForm = { ...candidateForm };
      updatedForm.initialState = {
        ...formData,
      };
      updatedForm.initialState.candidateResume = null;
      setCandidateForm(updatedForm);
    }
    // DOWNLOAD: handleDownload, // add your custom Actions
  };

  const handleToggleModal = () => {
    setShowModal(!showModal);
  };

  return (
    <>
      <form className="add-candidate-form">
        <div className="mt-2">
          {/* Render the form using the FormCreator component */}
          <FormCreator
            config={candidateForm}
            ref={candidateRef}
            key={shouldRerenderFormCreator}
            {...candidateForm}
            onActionChange={handleActionChange}
          ></FormCreator>
        </div>
      </form>
      <div className="form-btn d-flex align-items-center mt-3 mb-2">
        <div className="d-flex align-items-center justify-content-between w-100">
          <div>
            <Buttons
              imagePath={AppIcons.addIcon}
              buttonTypeClassName="theme-btn mr-3"
              onClick={handleToggleModal}
              buttonText="Create Candidate via Resume upload"
              isLoading={isCandidateAdding}
            />
          </div>
          <div className="d-flex align-items-center">
            <Buttons
              buttonTypeClassName="dark-btn"
              onClick={props.onClose}
              buttonText="Cancel"
            />
            <Buttons
              textWithIcon={false}
              imagePath={AppIcons.addIcon}
              buttonTypeClassName="theme-btn ml-5"
              onClick={handleAddClick}
              buttonText="Add"
              isLoading={isCandidateAdding}
            />
          </div>
        </div>
      </div>
      {showModal && (
        <CenterModel
          showModal={showModal}
          handleToggleModal={handleToggleModal}
          modalTitle="Upload Resume"
          modelSizeClass="w-40"
        >
          <UploadResumeCandidate handleToggleModal={handleToggleModal} />
        </CenterModel>
      )}
    </>
  );
};

export default AddUserForm;
